import { Http, Headers } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
var AuthService = /** @class */ (function () {
    function AuthService(http) {
        this.http = http;
        // set token if saved in local storage
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.token = currentUser && currentUser.token;
        this.username = currentUser && currentUser.username;
        this.roles = currentUser && currentUser.roles;
    }
    AuthService.prototype.login = function (username, password) {
        var _this = this;
        var headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        var body = "username=" + username + "&password=" + password + "&grant_type=password&client_id=" + environment.CLIENT_ID;
        return this.http.post(environment.API_ENDPOINT + "/token", body, { headers: headers })
            .map(function (response) {
            // login successful if there's a jwt token in the response
            var token = response.json() && response.json();
            var access_token = token.access_token;
            if (access_token) {
                // set token property
                _this.token = access_token;
                _this.username = username;
                _this.roles = token.roles;
                // store username and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify({ username: username, token: access_token, roles: token.roles }));
                // return true to indicate successful login
                return true;
            }
            else {
                // return false to indicate failed login
                return false;
            }
        }).catch(function (error) { return Observable.of(false); });
        ;
    };
    AuthService.prototype.logout = function () {
        // clear token remove user from local storage to log user out
        this.token = null;
        localStorage.removeItem('currentUser');
    };
    AuthService.ctorParameters = function () { return [{ type: Http }]; };
    return AuthService;
}());
export { AuthService };
//# sourceMappingURL=auth.service.js.map


// WEBPACK FOOTER //
// auth.service.js